var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAudioPause(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6076 28.7338V8.07871C15.6076 6.11934 14.7843 5.34375 12.685 5.34375H7.33373C5.2344 5.34375 4.41113 6.11934 4.41113 8.07871V28.7338C4.41113 30.6932 5.2344 31.4688 7.33373 31.4688H12.6438C14.7843 31.4688 15.6076 30.6932 15.6076 28.7338Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2687 28.7338V8.07871C34.2687 6.11934 33.4424 5.34375 31.3353 5.34375H26.0056C23.8986 5.34375 23.0723 6.11934 23.0723 8.07871V28.7338C23.0723 30.6932 23.8986 31.4688 26.0056 31.4688H31.3353C33.4424 31.4688 34.2687 30.6932 34.2687 28.7338Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudioPause);
export default __webpack_public_path__ + "static/media/audio_pause.7954be906dac8a42a76c2b5b798186fe.svg";
export { ForwardRef as ReactComponent };